import React, { useState } from 'react';

export const NavbarContext = React.createContext();

function NavbarContextComponent({ children }) {
  const [currentSection, setCurrentSection] = useState(null);

  return (
    <NavbarContext.Provider value={{ currentSection, setCurrentSection }}>
      {children}
    </NavbarContext.Provider>
  )
};

export default NavbarContextComponent;
